import { MD5, AES, enc, mode, pad } from "crypto-js"
import { SignatureKey, DecodeKey, DecodePrefix, testFlag } from "../config"
import { isString, isObject } from "./util"

function validateParam(value) {
    return value !== '' && value !== void 0 && value !== null && !isObject(value)
}

function stringify(params, sortedKeys) {
    const pairs = []
    if (!sortedKeys) {
        sortedKeys = Object.keys(params).sort()
    }
    sortedKeys.forEach(key => {
        validateParam(params[key]) && pairs.push(`${key}=${params[key]}`)
    })
    return pairs.join('&')
}

export const GenSignature = (headers, params) => {
    const rhs = stringify(headers, [
        'source',
        'uid',
        'vnum',
        'channelId',
        'companyCode',
        'appCode',
        'timestamp'
    ])
    if (!params) {
        return MD5(`${rhs}&${SignatureKey}`)
    }
    const rps = stringify(params)
    return MD5(`${rhs}&${rps}&${SignatureKey}`)
}

export const DecodeResContent = content => {
    if (!isString(content) || content.indexOf(DecodePrefix) < 0) {
        if (testFlag) {
            console.log(`res ${typeof content} content: `)
            console.log(content)
        }
        return content
    }
    const decrypt = AES.decrypt(
        content.replace(DecodePrefix, ''),
        enc.Utf8.parse(DecodeKey),
        {
            mode: mode.ECB,
            padding: pad.Pkcs7
        }).toString(enc.Utf8)
    try {
        const data = JSON.parse(decrypt)
        if (testFlag) {
            console.log(`res ${typeof data} data: `)
            console.log(data)
        }
        return data
    } catch (e) {
        if (testFlag){
            console.log(`res ${typeof decrypt} decrypt: `)
            console.log(decrypt)
        }
        return decrypt
    }
}